import { useState, useEffect } from "react";
import { Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { Link } from "react-router-dom";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { addressbook as addressbookService } from "@/services";

function AddressBookTable({ departmentType }) {
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();

  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return addressbookService.list(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          search: keyword,
          page,
          page_size: pageSize,
          department__types:
            departmentType === "all" ? undefined : departmentType,
        },
        auth.token
      );
    }
  }, [run, keyword, page, pageSize, auth, departmentType]);

  const columns = [
    {
      title: "类别",
      key: "types",
      render: (record) => {
        return record.department.types.map((t) => t.name).join(", ");
      },
    },
    {
      title: "名称",
      key: "name",
      render: (record) => (
        <Link to={`workshop/dwgl/${record.department.id}`}>
          {record.department.name}
        </Link>
      ),
    },
    {
      title: "办公电话",
      key: "office_phone",
      render: (record) => record.department.office_phone,
    },
    {
      title: "负责人",
      key: "director_name",
      render: (record) => record.department.director_name,
    },
    {
      title: "负责人手机",
      key: "director_phone",
      render: (record) => record.department.director_phone,
    },
    {
      title: "联系人",
      dataIndex: "name",
    },
    {
      title: "联系人手机",
      dataIndex: "phone",
    },
    {
      title: "登录账号",
      key: "office_phone",
      render: (record) => record.user?.username,
    },
  ];

  return (
    <div className="table-container">
      <div className="table-toolbar">
        <div className="left">
          <Link
            to="/addressbook"
            target="_blank"
            state={{ keyword, departmentType }}
            className="ant-btn ant-btn-primary"
          >
            打印
          </Link>
        </div>
        <div className="right">
          <Input
            prefix={<SearchOutlined style={{ color: "#ccc" }} />}
            style={{ width: 220 }}
            placeholder="搜索内容"
            allowClear
            onChange={(e) => setKeyword(e.target.value)}
          />
        </div>
      </div>
      <Table
        rowKey="user_id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default AddressBookTable;
